<style scoped lang="less">
.layout{position: absolute; background: rgba(2, 36 ,38,.5);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;bottom: 12px;height: 175px; top: 189px;left: 270px;transform: translate(-50%, -50%);border: 1px solid #23fffc;border-radius: 10px;}
.title{height: 35px;background: rgba(33, 185, 191, 0.6);margin: 0;line-height: 35px;text-align: right;padding: 0 20px;color: #fff; font-size: 16px;display: flex;justify-content: space-between;}
.popup-tool {height: 45px;line-height: 45px;color: #fff; font-family: Microsoft YaH;text-align: left;padding: 0px 10px;border:solid 1px rgb(33, 185, 191)}
.popup-content {color: #d6d4d4; font-family: Microsoft YaH;text-align: left;padding: 5px;border-top: none;}
.ol-popup-closer:after {content: "✖";}
/deep/.el-input.is-disabled .el-input__inner {background: rgba(10, 17, 43, 0.4);border: solid 1px #3c818d;}
/deep/.el-select .el-input.is-disabled .el-input__inner:hover {border: solid 1px #3c818d;}
/deep/.el-form-item__label {padding: 0;color: #23fffc;text-align: center;}
/deep/.el-form-item {margin-bottom: 5px;}
/deep/.el-input__inner {color: #23fffc;}
.markbox {height: 40px;width: 250px;display: flex;flex-direction: row; justify-content:space-around;padding: 0;margin: 0;list-style: none;}
.el-radio-button {width: 40px;height: 40px;}
/deep/.el-radio-button__inner {width: 40px;height: 40px;}
/deep/.el-radio-button__inner img{width: 40px;height: 40px;position: absolute;top: 0px;left: 0px;}
.el-button {border-radius: 20px;border: solid 1px #3c818d;}
.el-button--primary {color: #FFF;background-color: rgba(33, 185, 191, 0.6);}
.el-button--default {color: #FFF;background: rgba(10, 17, 43, 0.4);}
</style>

<template>
<div class="layout" v-drag v-if="flag">
    <p class="title">
      <span>坐标定位</span>
      <a href="#" id="popup-closer" class="ol-popup-closer" @click="closePul(false)"></a>
    </p>
    <div class="popup-content">
      <el-form ref="form" :model="form" label-width="90px">
        <el-form-item label="请输入经度：">
          <el-input v-model="form.longitude"></el-input>
        </el-form-item>
        <el-form-item label="请输入纬度：">
          <el-input v-model="form.latitude"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">确定</el-button>
          <el-button @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import Vector from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Icon from 'ol/style/Icon'
import Style from 'ol/style/Style'
export default {
  data()
  {
    return {
      flag: false,
      form: {
        longitude: '',
        latitude: ''
      },
      LayernarData: []
    }
  },
  methods: {
    showLP()
    {
      if (this.flag)
        this.flag = false
      else
        this.flag = true
    },
    closePul(show)
    {
      this.flag = show
    },
    onSubmit()
    {
      if (this.form.longitude && this.form.latitude)
        this.clickMark(this.form)
      else
        this.$message({message: '请先输入经纬度', type: 'warning', customClass: 'mzindex'})
    },
    clickMark()
    {
      let self = this
      window.map.getView().animate({ // 只设置需要的属性即可
        center: [this.form.longitude, this.form.latitude], // 中心点
        zoom: 9, // 缩放级别
        rotation: undefined, // 缩放完成view视图旋转弧度
        duration: 2000 // 缩放持续时间，默认不需要设置
      })
      let coordinate = [this.form.longitude, this.form.latitude]
      let rome = new Feature({
        geometry: new Point(coordinate) //几何信息
      })
      var vector = new Vector()
      vector.addFeature(rome)
      var wfsVectorLayer = new VectorLayer({
        source: vector,
        style: new Style({
          image: new Icon({
            color: '#BADA55',
            crossOrigin: 'anonymous',
            src: '../../../../../static/index/map-marker (1).png'
          })
        })
      })
      self.LayernarData.push(wfsVectorLayer)
      window.map.addLayer(wfsVectorLayer)
      self.flag = false
    },
    cancel()
    {
      this.closePul(false)
      this.clear()
      this.form.longitude = ''
      this.form.latitude = ''
    },
    clear()
    {
      this.LayernarData.forEach(e =>
      {
        e.getSource().clear()
        window.map.removeLayer(e)
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/Coordinates.vue